import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  AboutUs,
  HeroSection,
  IncubationPartners,
  ScrollNavbar,
  SearchSection,
} from "../../components";
import Features from "../../components/Landing/Features";
import Banner from "../../components/Landing/Banner";
import Footer from "../../components/Footer/Footer";
import Services from "../../components/Landing/Services";
import { City } from "../../services/searchService";
import ComingSoon from "../../components/Landing/ComingSoon";
import SearchSectionNew from "../../components/Landing/SearchSectionNew/SearchSectionNew";

const Landing = () => {
  const history = useHistory();

  // Trip type state
  const [activeTab, setActiveTab] = useState<
    "one-way" | "round-trip" | "airport" | "hourly"
  >("one-way");

  // Form data states
  const [source, setSource] = useState<City | null>(null);
  const [destination, setDestination] = useState<City | null>(null);
  const [departureDate, setDepartureDate] = useState<string>("");
  const [returnDate, setReturnDate] = useState<string>("");
  const [pickupTime, setPickupTime] = useState<string>("");
  const [dropTime, setDropTime] = useState<string>("");
  const [hourlyDuration, setHourlyDuration] = useState<string>("4");
  const [sourceSearch, setSourceSearch] = useState<string>("");
  const [destSearch, setDestSearch] = useState<string>("");

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  const handleSearch = () => {
    const params = new URLSearchParams();

    // Add search parameters
    params.set("trip-type", activeTab);
    if (source) params.set("source", source.name);
    if (destination) params.set("destination", destination.name);
    if (departureDate) params.set("departure-date", departureDate);
    if (returnDate) params.set("return-date", returnDate);
    if (pickupTime) params.set("pickup-time", pickupTime);
    if (dropTime) params.set("drop-time", dropTime);
    if (activeTab === "hourly" && hourlyDuration) {
      params.set("hourly-duration", hourlyDuration);
    }

    // Redirect to dashboard with search params
    history.push({
      pathname: "/dashboard",
      search: params.toString(),
    });
  };

  const handleClearFilter = () => {
    // Reset form states but keep the active tab
    setSource(null);
    setDestination(null);
    setSourceSearch("");
    setDestSearch("");
    setDepartureDate("");
    setReturnDate("");
    setPickupTime("");
    setDropTime("");
    setHourlyDuration("4");
  };

  const isSearchEnabled = (() => {
    if (!source || !departureDate || !pickupTime) {
      return false;
    }

    if (activeTab === "one-way" || activeTab === "airport") {
      if (!destination) {
        return false;
      }
    }

    if (activeTab === "round-trip") {
      if (!destination || !returnDate || !dropTime) {
        return false;
      }
    }

    return true;
  })();

  const showClearButton = !!(
    source ||
    destination ||
    departureDate ||
    returnDate ||
    pickupTime ||
    dropTime ||
    sourceSearch ||
    destSearch
  );

  return (
    <>
      <ScrollNavbar />
      <div
        className="px-4 sm:px-8 lg:px-12"
        style={{ maxWidth: "1400px", margin: "0 auto" }}
      >
        <section className="mb-20">
          <HeroSection />
        </section>

        <section className="my-20 relative z-50">
          {/* <ComingSoon /> */}
          <SearchSectionNew
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            source={source}
            setSource={setSource}
            destination={destination}
            setDestination={setDestination}
            departureDate={departureDate}
            setDepartureDate={setDepartureDate}
            returnDate={returnDate}
            setReturnDate={setReturnDate}
            pickupTime={pickupTime}
            setPickupTime={setPickupTime}
            dropTime={dropTime}
            setDropTime={setDropTime}
            hourlyDuration={hourlyDuration}
            setHourlyDuration={setHourlyDuration}
            sourceSearch={sourceSearch}
            setSourceSearch={setSourceSearch}
            destSearch={destSearch}
            setDestSearch={setDestSearch}
            handleSearch={handleSearch}
            handleClearFilter={handleClearFilter}
            isSearchEnabled={isSearchEnabled}
            showClearButton={showClearButton}
          />
          {/* <h2 className="text-center text-lg font-medium">Launching Soon!</h2> */}
        </section>

        <section className="my-20">
          <AboutUs />
        </section>

        <section className="my-20">
          <Services />
        </section>

        <section className="my-20">
          <Features />
        </section>

        <section className="my-20">
          <IncubationPartners />
        </section>

        <section>
          <Banner />
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Landing;
